module.exports = __webpack_public_path__ + "img/regular_cycle_3.bfb3c7b1.jpg";